import axios from "axios";
const API_HOST = process.env.REACT_APP_API_HOST;

class Website_Service { 

  deletewebsite(data, user) {
    return axios({
      method: "post",
      url: API_HOST + "/api/admin/save-website-request",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }
  getWebsiteDetails(user, page, search , pageLimit) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/get-website-name?page=${page}&pageSize=${pageLimit}&search=${search}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    activeInactiveWebsite(id, data, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/website/isactive/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    manualWebsiteDeposit(id, data, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/add-website-balance/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    manualWebsiteWithdraw(id, data, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/withdraw-website-balance/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


    permissionRenewWebsite(data, id, user) {
    return axios({
      method: "put",
      url: `${API_HOST}/api/website/edit-request/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    getWebsiteStatement(user, id, filter, page , pageSize ) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/manual-user-website-account-summary/${id}?page=${page}&pageSize=${pageSize}`,
      data: {filters : filter},
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    searchWebsiteList(user, search) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/admin/website-name?search=${search}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    addWebsite(data, user) {
    return axios({
      method: "post",
      url: API_HOST + "/api/add-website-name",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


  
  editWebsite(data, id, user) {
    return axios({
      method: "put",
      url: `${API_HOST}/api/website-edit/${id}`,
      data: data,

      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  getWebsiteAllRequest(user, page, limit, search = "", type = "") {
    return axios({
      method: "get",
      url: `${API_HOST}/api/admin/get-all-web-request?page=${page}&pageSize=${limit}&search=${search}&type=${type}`,
      // data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  websiteRequestApproveReject(user, data) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/approve-website`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

}


export default new Website_Service();